export default __webpack_public_path__ + "c73cbd2eb40a27ae4e4efd765d2d6d65.jpg";